import { z } from "zod";
export const npdCompositionDtoSchema = z.object({
    componentId: z.number(),
    componentName: z.string(),
    componentCategory: z.string(),
    componentUnit: z.string(),
    componentQuantity: z.number(),
});
